<template>
  <div>
    <mail-top></mail-top>
    <mail-list></mail-list>
  </div>
</template>

<script>
import Top from '@/views/customer/pages/mail/Top.vue';
import List from '@/views/customer/pages/mail/List.vue';

export default {
  name: 'mail',
  components: {
    'mail-top': Top,
    'mail-list': List
  }
};
</script>
